import { groupBy } from 'helpers/arr';

export const dataToShifts = (shiftsData = []) => {
  const shifts = groupBy(shiftsData, ['shift_name', 'workday'], true).reduce((shifts, shiftData) => {
    const { shift_name, start_hr, workday } = shiftData[0];
    const { end_hr } = shiftData[shiftData.length - 1];
    shifts[shift_name] = shifts[shift_name] || { shift_name, workHours: [], breakHours: [] };
    shifts[shift_name].workHours.push({
      start_hr,
      end_hr,
      workday
    });
    shiftData.filter(s => s.period_type === 'break').forEach(breakHour => {
      const { start_hr, end_hr, day_of_week } = breakHour;
      shifts[shift_name].breakHours.push({
        start_hr,
        end_hr,
        workday:day_of_week
      }); 
    });
    return shifts;
  }, {});

  return Object.values(shifts);
};

export const shiftsToData = (shifts, scheduleId) => {
  let data = [];
  
  shifts.forEach(shift => {
    const adjustedBreaks = adjustBreakWorkDay(shift.breakHours, shift.workHours);
    const breakHoursGroup = groupBy(adjustedBreaks, 'workday');
    const workHours = [...shift.workHours];
    workHours.sort((a, b) => a.workday - b.workday);
    
    let parts = [];
    workHours.forEach(workHour => {
      const shiftGoesNextDay = workHour.start_hr > workHour.end_hr;
      let partNo = 1
      const breakHours = breakHoursGroup[workHour.workday] || [];
      sortBreakHours(breakHours, workHour);
      let dayOfWeek = workHour.workday, prevHour = workHour.start_hr;
      breakHours.forEach(breakHour => {
        if (Math.abs(prevHour - breakHour.start_hr) > 0 && prevHour !==23.99) {   
          parts.push({
            day_of_week: dayOfWeek,
            start_hr: prevHour,
            end_hr: breakHour.start_hr < prevHour ? 23.99 : breakHour.start_hr,
            part_no: partNo++,
            period_type: "work",
            schedule_id: scheduleId,
            shift_name: shift.shift_name,
            workday: workHour.workday,
          });
          if(shiftGoesNextDay && (breakHour.start_hr!==0 && breakHour.start_hr!==23.99) && breakHour.start_hr < prevHour){
          parts.push({
            day_of_week: (dayOfWeek % 7) + 1,
            start_hr: 0,
            end_hr: breakHour.start_hr,
            part_no: partNo++,
            period_type: "work",
            schedule_id: scheduleId,
            shift_name: shift.shift_name,
            workday: workHour.workday,
          });
        
        }
        }
        if (prevHour > breakHour.start_hr) {
          dayOfWeek = (dayOfWeek % 7) + 1;
        }
        if(breakHour.start_hr<breakHour.end_hr)
         {parts.push({
          day_of_week: dayOfWeek,
          start_hr: breakHour.start_hr,
          end_hr: breakHour.end_hr,
          part_no: partNo++,
          period_type: 'break',
          schedule_id: scheduleId,
          shift_name: shift.shift_name,
          workday: workHour.workday,
        });}
        prevHour = breakHour.end_hr;
      });
      
        if (Math.abs(prevHour - workHour.end_hr) > 0) {
          parts.push({
            day_of_week: dayOfWeek,
            start_hr: prevHour===23.99 ? 0 : prevHour,
            end_hr: workHour.end_hr,
            part_no: partNo++,
            period_type: "work",
            schedule_id: scheduleId,
            shift_name: shift.shift_name,
            workday: workHour.workday,
          });
        }
    });

    data = data.concat(parts);
  });
  return data;
};

function adjustBreakWorkDay(breakHours, workHours) {
  breakHours.forEach((breakItem) => {
    const previousBreakWorkDay = breakItem.workday !== 1 ? breakItem.workday - 1 : 7;
  
    for (const workItem of workHours) {
      if (workItem.start_hr < workItem.end_hr) {
        continue;
      } else if (
        previousBreakWorkDay === workItem.workday &&
        breakItem.start_hr < workItem.start_hr 
      ) {
        breakItem.workday = previousBreakWorkDay;
        break;
      }
    }
  });
  return breakHours;
}

function sortBreakHours(breakHours, workHour) {
  if (workHour.start_hr < workHour.end_hr)
    breakHours.sort((a, b) => a.start_hr - b.start_hr);
  else
    breakHours.sort((a, b) => {
      if (a.start_hr > workHour.start_hr && b.start_hr > workHour.start_hr) {
        return a.start_hr - b.start_hr;
      } else if (a.start_hr > workHour.start_hr) {
        return -1;
      } else if (b.start_hr > workHour.start_hr) {
        return 1;
      } else {
        return a.start_hr - b.start_hr;
      }
    });
}